import React from 'react';
import PropTypes from 'prop-types';

export default function LoadingOnText({ width, height, display }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: 'auto',
        background: 'none',
        display: display,
        shapeRendering: 'auto',
      }}
      width={width}
      height={height}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="#477aff"
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        ></animateTransform>
      </circle>
    </svg>
  );
}

LoadingOnText.defaultProps = {
  width: '200px',
  height: '50px',
  display: 'block',
};

LoadingOnText.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  display: PropTypes.string,
};
